export const plugPrefix = "_plug/";
export const stdLibPrefix = "Library/Std/";
